module.exports = __webpack_public_path__ + "static/img/test.d0b3e35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test.jpg
// module id = p6y8
// module chunks = 29